import type { IDelLayerData } from '@/framework';
import type { ILayerProps } from '@/version-types';

/** 历史记录类型 **/
export enum HistoryType {
    /** 成组 */
    PACK = 'pack:o-group',
    /** 解组 */
    UNPACK = 'unpack:o-group',
    /** 合并 */
    MERGE = 'merge:o-group',
}

/** 图层组快捷键类型 */
export enum GroupLayerHotkeyType {
    /** 成组 */
    PACK = HistoryType.PACK,
    /** 解组 */
    UNPACK = HistoryType.UNPACK,
}

/** 合并 */
export type IHistoryMergeData = {
    /** 删除的数据 */
    delData: IDelLayerData;
    /** 插入的数据 */
    insertData: ILayerProps;
};

/** 成组 */
export type IHistoryPackData = {
    /** 渲染数据，多人协作时，需要同步 */
    item: {
        childIndexes: number[];
        childIds: string[];
        layer: ILayerProps;
        layerIndex: number;
        oldLayer?: ILayerProps;
        newLayer?: ILayerProps;
    };
};

/** 解组 */
export type IHistoryUnpackData = {
    /** 渲染数据，多人协作时，需要同步 */
    item: {
        layer: ILayerProps;
        layerIndex: number;
    };
};
